import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Loader2, AlertCircle, Users } from "lucide-react";
import { useTeams } from "@/hooks/useTeams";
import TeamCard from "@/components/teams/TeamCard";

export default function TeamsPage() {
  const { t } = useTranslation("pages");
  const { data: teams, isLoading, error } = useTeams();
  const navigate = useNavigate();

  if (isLoading) {
    return (
      <div className="page-container flex items-center justify-center min-h-[50vh]">
        <div className="flex items-center space-x-2">
          <Loader2 className="h-8 w-8 animate-spin text-primary-600" />
          <span className="text-secondary-600">{t("teams.loading")}</span>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="page-container flex items-center justify-center min-h-[50vh]">
        <div className="text-center">
          <AlertCircle className="h-12 w-12 text-red-500 mx-auto mb-4" />
          <h2 className="text-xl font-semibold text-secondary-900 mb-2">
            {t("teams.errorTitle")}
          </h2>
          <p className="text-secondary-600">{t("teams.errorMessage")}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="page-container">
      <div className="mb-3 sm:mb-8">
        <h1 className="page-title">{t("teams.title")}</h1>
        <p className="page-subtitle">{t("teams.pageSubtitle")}</p>
      </div>

      {teams && teams.length > 0 ? (
        <>
          <div className="mb-4 sm:mb-6">
            <p className="text-sm text-secondary-600">
              {t("teams.teamCount", { count: teams.length })}
            </p>
          </div>
          <div className="flex flex-col gap-2">
            {teams.map((team) => (
              <TeamCard
                key={team.id}
                team={team}
                onClick={() => navigate(`/teams/${team.id}`)}
              />
            ))}
          </div>
        </>
      ) : (
        <div className="text-center py-8 sm:py-12">
          <Users className="h-10 w-10 sm:h-12 sm:w-12 text-secondary-400 mx-auto mb-4" />
          <h2 className="text-lg sm:text-xl font-semibold text-secondary-900 mb-2">
            {t("teams.noTeams")}
          </h2>
          <p className="text-secondary-600 text-sm sm:text-base px-4">
            {t("teams.noTeamsMessage")}
          </p>
        </div>
      )}
    </div>
  );
}
